import { jsx } from 'react/jsx-runtime';
import { InputBase } from '../InputBase/InputBase.js';
import '@headlessui/react';
import 'clsx';
import '@react-icons/all-files/bs/BsArrowBarLeft.js';
import '@react-icons/all-files/bs/BsArrowBarRight.js';
import '@react-icons/all-files/bs/BsLayersFill.js';
import '@react-icons/all-files/bs/BsStars.js';
import '@react-icons/all-files/cg/CgSidebarOpen.js';
import '@react-icons/all-files/cg/CgSidebarRight.js';
import '@react-icons/all-files/fa/FaChevronDown.js';
import '@react-icons/all-files/fa/FaFileDownload.js';
import '@react-icons/all-files/fa/FaRedditSquare.js';
import '@react-icons/all-files/fa/FaSalesforce.js';
import '@react-icons/all-files/fa/FaSlack.js';
import '@react-icons/all-files/fa/FaTelegram.js';
import '@react-icons/all-files/fa6/FaSquareXTwitter.js';
import '@react-icons/all-files/fi/FiColumns.js';
import '@react-icons/all-files/md/MdAdd.js';
import '@react-icons/all-files/md/MdArrowBack.js';
import '@react-icons/all-files/md/MdArrowDropDown.js';
import '@react-icons/all-files/md/MdArrowForward.js';
import '@react-icons/all-files/md/MdBolt.js';
import '@react-icons/all-files/md/MdCheck.js';
import '@react-icons/all-files/md/MdClose.js';
import '@react-icons/all-files/md/MdDragIndicator.js';
import '@react-icons/all-files/md/MdEmail.js';
import '@react-icons/all-files/md/MdErrorOutline.js';
import '@react-icons/all-files/md/MdFileDownloadDone.js';
import '@react-icons/all-files/md/MdFilterList.js';
import '@react-icons/all-files/md/MdHelpOutline.js';
import '@react-icons/all-files/md/MdInfoOutline.js';
import '@react-icons/all-files/md/MdLanguage.js';
import '@react-icons/all-files/md/MdLink.js';
import '@react-icons/all-files/md/MdModeEditOutline.js';
import '@react-icons/all-files/md/MdMoreVert.js';
import '@react-icons/all-files/md/MdOutlineHistory.js';
import '@react-icons/all-files/md/MdOutlinePlaylistAdd.js';
import '@react-icons/all-files/md/MdOutlineSmartToy.js';
import '@react-icons/all-files/md/MdOutlineThumbDown.js';
import '@react-icons/all-files/md/MdOutlineThumbUp.js';
import '@react-icons/all-files/md/MdOutlineWarningAmber.js';
import '@react-icons/all-files/md/MdPerson.js';
import '@react-icons/all-files/md/MdPhone.js';
import '@react-icons/all-files/md/MdRemove.js';
import '@react-icons/all-files/md/MdShare.js';
import '@react-icons/all-files/pi/PiCalendarDotsLight.js';
import '@react-icons/all-files/pi/PiCloud.js';
import '@react-icons/all-files/pi/PiCloudFog.js';
import '@react-icons/all-files/pi/PiCloudLightning.js';
import '@react-icons/all-files/pi/PiCloudMoon.js';
import '@react-icons/all-files/pi/PiCloudRain.js';
import '@react-icons/all-files/pi/PiCloudSnow.js';
import '@react-icons/all-files/pi/PiCloudSun.js';
import '@react-icons/all-files/pi/PiDiamondsFour.js';
import '@react-icons/all-files/pi/PiFilePdf.js';
import '@react-icons/all-files/pi/PiListMagnifyingGlass.js';
import '@react-icons/all-files/pi/PiMapPinLineLight.js';
import '@react-icons/all-files/pi/PiMoon.js';
import '@react-icons/all-files/pi/PiMoonStars.js';
import '@react-icons/all-files/pi/PiSun.js';
import '@react-icons/all-files/pi/PiSunHorizon.js';
import '@react-icons/all-files/pi/PiTable.js';
import '@react-icons/all-files/pi/PiTabsFill.js';
import '@react-icons/all-files/pi/PiTag.js';
import '@react-icons/all-files/pi/PiWaveform.js';
import '@react-icons/all-files/rx/RxCopy.js';
import '@react-icons/all-files/rx/RxExternalLink.js';
import '@react-icons/all-files/vsc/VscSymbolKeyword.js';

function InputText({ type = "text", name, label, placeholder, description, rules, value, defaultValue, maxLength, disabled, autoComplete, onChange, textFormatter, autoFocus, }) {
    return (jsx(InputBase, { type: type, name: name, label: label, placeholder: placeholder, description: description, rules: rules, value: value, defaultValue: defaultValue, maxLength: maxLength, disabled: disabled, autoComplete: autoComplete, onChange: onChange, textFormatter: textFormatter, autoFocus: autoFocus }));
}

export { InputText };
//# sourceMappingURL=InputText.js.map
